import './PauseGeneral.css';
import CircleButton from '../../components/CircleButton';
import { useStore } from '@hmpu/powerups.store';
import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { useTranslate } from '@hmpu/powerups.intl.legacy.hooks.use-translate';
import { useLocalizedImg } from '@hmpu/powerups.intl.hooks.use-localized-img';
import { ReactComponent as PausedIcon } from './pause.svg';
// import SettingsPanel from 'components/SettingsPanel';
import { useEffect } from 'react';
import GAME_PAGES from '../../constants/GAME_PAGES';
import CTAButton from '../../components/CTAButton/CTAButton';
// import { SettingsDialog } from '@hmpu/powerups.ui.dialogs.settings';
import { SettingsDialog } from '../../components/settings';
import useResetFocus from '../../hooks/useResetFocus';
import { NavBar } from '@hmpu/powerups.ui.nav-bar';

export const PauseGeneral = ({ tabBack }) => {
  const translate = useTranslate();
  const page = useStore((state) => state.currentPage);
  const parentNode = 'PAUSE_MENU';
  const { __t } = useTranslation('PAUSE_MENU');
  const bgImg = translate('bgImg', parentNode);
  const pageData = useStore((state) => state.localeConfig['PAUSE_MENU']);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const setIsPauseEnabled = useStore((state) => state.setIsPauseEnabled);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const h1 = translate('hiddenH1', parentNode);
  const inPortrait = useStore((state) => state.inPortrait);
  const pageTitle = translate('pageTitle', parentNode);
  const setPageTitle = useStore((state) => state.setPageTitle);

  useEffect(() => {
    setPageTitle(translate('pageTitle', 'PAUSE_MENU'));
  }, [showSettingsPanel, inPortrait, isPauseEnabled]);

  useResetFocus([showSettingsPanel, inPortrait, isPauseEnabled]);

  useEffect(() => {
    setIsPauseEnabled(true);
    setPageTitle(pageTitle);
    window.dispatchEvent(
      new CustomEvent('pausePC', {
        detail: {
          // showPauseButton: false,
          isPauseEnabled: true,
        },
      })
    );
    document.activeElement.blur();
    document.getElementById('settingsButton')?.focus();
  }, []);

  const isPauseMenuDisplayed = useStore((state) => state.isPauseMenuDisplayed);

  const mainContentHidden =
  !inPortrait || showSettingsPanel || isPauseMenuDisplayed || isPauseEnabled;

  return (
    <section
      className='pause-general'
      role="dialog"
      aria-modal="true"
      title={pageTitle}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        zIndex: 1000,
        background: '#e3e3e3',
        backgroundImage: `url(${bgImg})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',   
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {inPortrait && (
        <SettingsDialog />
      )}
      <div className="pause-menu-content">
        <div className="pause-icon-container">
          {/* <PausedIcon className="pause-icon" /> */}
          <div className="pause-icon" />
          <h1 className='pauseH1' aria-label={__t('h1')}>{__t('h1')}</h1>
        </div>
        <div className="pause-btn-list">
          <CTAButton
            className="resume-btn"
            primary
            onClick={(evt) => {
              tabBack();
            }}
            intlKey={'resumeButton'}
            parentNode={parentNode}
          />
        </div>
      </div>
    </section>
  );
};
